import React from 'react';
import ErrorLayout from '../../components/ErrorLayout';

const ServerError = () => (
  <ErrorLayout 
    code={500} 
    title="Internal Server Error" 
    message="Something went wrong on our end. Our team has been notified and is working to fix it." 
    icon="pi pi-exclamation-triangle" 
    color="#c0392b" 
  />
);
export default ServerError;